import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../firebase';
import { onAuthStateChanged, signInWithRedirect, getRedirectResult } from 'firebase/auth';

const AuthContext = createContext();

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Handle redirect result first
        getRedirectResult(auth).then((result) => {
            if (result) {
                setCurrentUser(result.user);
            }
        }).catch((error) => {
            console.error('Redirect result error:', error);
        });

        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setCurrentUser(user);
            setLoading(false);
        }, (error) => {
            console.error('Auth state change error:', error);
            setLoading(false);
        });

        // Timeout fallback - if auth takes too long, stop loading
        const timeout = setTimeout(() => {
            setLoading(false);
        }, 10000); // 10 seconds

        return () => {
            unsubscribe();
            clearTimeout(timeout);
        };
    }, []);

    const value = {
        currentUser,
        loading
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
} 